<template>
	<div class="chart-line-container" :style="height ? {'height': height + 'px'} : {}">
		<canvas ref="chart" :style="height ? {'height': height + 'px', 'width': '100%'} : {'width': '100%'}"></canvas>
	</div>
</template>

<script>
    import { Chart, registerables } from 'chart.js';
    Chart.register(...registerables);

    export default ({
        props: [
            'data',
            'height',
            'title',
            'titleEjeY'
        ],
        data(){
            return {
                chart: null,
            } ;
        },
        mounted () { 
            let ctx = this.$refs.chart.getContext("2d");

            this.chart = new Chart(ctx, {
                type: "line",
                data: this.data,
                 options: {
                    layout: {
                        padding: {
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
					// devicePixelRatio: 1,
                    plugins: {
                        legend: {
                            display: false,
                        },
                        title: {
                            display: true,
                            text: this.title,
                            font: {
                                size: 12,
                            },
                            position: 'top',

                        },
                    },
                    tooltips: {
                        enabled: true,
                        mode: "index",
                        intersect: false,
                    },
                    scales: {
                        x: {
                            display: false,
                            grid: {
                                drawBorder: false
                            },
                            ticks: {
                                padding: 0,
								font: {
									size: 14,
									lineHeight: 2.5,
									weight: '400',
									family: "Open Sans",
								},
                            }
                        },
                        y: {
                            display: true,
                            grid: {
                                drawBorder: false
                            },
                            ticks: {
                                padding: 5,
								
                            },
							title: {
								display: true,
								text: this.titleEjeY,
                                font: {
                                    size: 14,
                                    weight: '600',
                                    family: "Open Sans",
                                },
                                padding: {
                                    top: 0,
                                    bottom: 10
                                },
                                grid: {
                                    drawBorder: false
                                },
							},
                        },
                    },
                    interaction: {
                        intersect: false,
                    },
                }
            });
        },
        // Right before the component is destroyed,
        // also destroy the chart.
        beforeDestroy: function () {
            this.chart.destroy() ;
        },
    })

</script>

<style lang="scss" scoped>
/* Contenedor que se ajusta exactamente al gráfico */
.chart-line-container {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  line-height: 0; /* elimina espacios de texto */
  font-size: 0;   /* elimina espacios inline */
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Canvas sin márgenes */
canvas {
  margin: 0 !important;
  padding: 0 !important;
  display: block;
  box-sizing: border-box;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
</style>